import { FC } from 'react';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { ButtonBase } from '../../../../common';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';

const FATCARequireCertificationScreen: FC<{
  translations: FATCATranslations;
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
}> = ({ translations, fatcaFormState }) => {
  return (
    <div>
      <ButtonBase
        fullWidth
        size="large"
        onClick={() => {
          fatcaFormState.onNextStep();
        }}
      >
        {translations.iAgree}
      </ButtonBase>
    </div>
  );
};

export { FATCARequireCertificationScreen };
